import CodeError from './CodeError';

class NotAuthenticatedError extends CodeError {
  constructor() {
    const code = 'notAuthenticated';
    const message = 'The user made a request and received an unauthenticated response';
    super(code, message);
    if ('function' === typeof Error.captureStackTrace) {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = (new Error(message)).stack;
    }
  }
}

export default NotAuthenticatedError;
